"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YstTreatmentResponseLabel = exports.YstMentalHealthConcernLabels = exports.YstMentalHealthConcerns = exports.YstMentalHealthConcern = exports.YstMentalHealthGeneralResourceLabels = exports.YstMentalHealthGeneralResource = void 0;
const zod_1 = require("zod");
exports.YstMentalHealthGeneralResource = {
    TIPS_FOR_TALKING_TO_TEENS: 'TIPS_FOR_TALKING_TO_TEENS',
    RECOGNIZING_WARNING_SIGNS: 'RECOGNIZING_WARNING_SIGNS',
    TEEN_MENTAL_HEALTH: 'TEEN_MENTAL_HEALTH',
    TEEN_DEPRESSION: 'TEEN_DEPRESSION',
    CRISIS: 'CRISIS',
};
exports.YstMentalHealthGeneralResourceLabels = {
    TIPS_FOR_TALKING_TO_TEENS: 'Tips for talking with teens',
    RECOGNIZING_WARNING_SIGNS: 'Recognizing warning signs',
    TEEN_MENTAL_HEALTH: 'Teen mental health',
    TEEN_DEPRESSION: 'Teen depression',
    CRISIS: 'Emergency Resources',
};
exports.YstMentalHealthConcern = {
    SUICIDE_RISK: 'SUICIDE_RISK',
    DEPRESSION: 'DEPRESSION',
    BIPOLAR_DISORDER: 'BIPOLAR_DISORDER',
    ALCOHOL_ABUSE: 'ALCOHOL_ABUSE',
    DRUG_ABUSE: 'DRUG_ABUSE',
    SOCIAL_ANXIETY: 'SOCIAL_ANXIETY',
    GENERAL_ANXIETY: 'GENERAL_ANXIETY',
    PTSD: 'PTSD',
    ADHD: 'ADHD',
    EATING_DISORDER: 'EATING_DISORDER',
    SLEEP_PROBLEMS: 'SLEEP_PROBLEMS',
    CONDUCT_DISORDER: 'CONDUCT_DISORDER',
    AGGRESSION: 'AGGRESSION',
    GRIEF: 'GRIEF',
    BULLYING: 'BULLYING',
    TRAUMA: 'TRAUMA',
    DISCRIMINATION: 'DISCRIMINATION',
};
exports.YstMentalHealthConcerns = zod_1.z
    .object({
    generalResources: zod_1.z
        .record(zod_1.z.nativeEnum(exports.YstMentalHealthGeneralResource), zod_1.z.coerce.boolean())
        .optional(), // This is only used for YST_SUPPORT patients
    concerns: zod_1.z.record(zod_1.z.nativeEnum(exports.YstMentalHealthConcern), zod_1.z.boolean()),
    medication: zod_1.z.object({
        status: zod_1.z.enum(['YES', 'NO', 'SOON', 'UNKNOWN']).nullish(),
        description: zod_1.z.string(),
    }),
    therapy: zod_1.z.object({
        status: zod_1.z.enum(['YES', 'NO', 'SOON', 'UNKNOWN']).nullish(),
        description: zod_1.z.string(),
    }),
    treatmentResponse: zod_1.z.union([
        zod_1.z.number().int().min(0).max(4).nullish(),
        zod_1.z
            .string()
            .refine((value) => {
            const numberValue = Number(value);
            return (!Number.isNaN(numberValue) &&
                Number.isInteger(numberValue) &&
                numberValue >= 0 &&
                numberValue <= 4);
        }, {
            message: 'treatmentResponse must be an integer between 0 and 4',
            path: ['treatmentResponse'],
        })
            .transform((value) => Number(value)),
    ]),
})
    .default(() => ({
    concerns: {},
    medication: { status: null, description: '' },
    therapy: { status: null, description: '' },
    treatmentResponse: null,
}));
exports.YstMentalHealthConcernLabels = {
    SUICIDE_RISK: 'Suicide Risk',
    DEPRESSION: 'Depression',
    BIPOLAR_DISORDER: 'Bipolar Disorder',
    ALCOHOL_ABUSE: 'Alcohol Misuse',
    DRUG_ABUSE: 'Drug Misuse',
    SOCIAL_ANXIETY: 'Social Anxiety',
    GENERAL_ANXIETY: 'General Anxiety',
    PTSD: 'PTSD',
    ADHD: 'ADHD',
    EATING_DISORDER: 'Eating Disorders',
    SLEEP_PROBLEMS: 'Sleep Problems',
    CONDUCT_DISORDER: 'Conduct Disorder',
    AGGRESSION: 'Aggression',
    GRIEF: 'Coping with Grief',
    BULLYING: 'Dealing with Bullying',
    TRAUMA: 'Trauma',
    DISCRIMINATION: 'Discrimination',
};
exports.YstTreatmentResponseLabel = {
    0: 'Very poorly',
    1: 'Poorly',
    2: 'No change',
    3: 'Well',
    4: 'Very well',
};
//# sourceMappingURL=ystMentalHealthConcerns.js.map